import { render, staticRenderFns } from "./labelmodal.vue.html?vue&type=template&id=7187171e&scoped=true"
import script from "./labelmodal.controller?vue&type=script&lang=js&external"
export * from "./labelmodal.controller?vue&type=script&lang=js&external"
import style0 from "./labelmodal.vue.html?vue&type=style&index=0&id=7187171e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7187171e",
  null
  
)

export default component.exports